import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/images/image009.png'
import _imports_1 from '../assets/images/image010.png'
import _imports_2 from '../assets/images/image001.png'
import _imports_3 from '../assets/images/image003.png'


const _hoisted_1 = { id: "homeCompanyLogoWrap" }
const _hoisted_2 = {
  class: "el-dropdown-link",
  style: {"border":"0px solid #000","color":"#DDD"}
}
const _hoisted_3 = {
  class: "el-dropdown-link",
  style: {"border":"0px solid #000","color":"#DDD"}
}
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["placeholder", "onKeydown"]
const _hoisted_8 = { style: {"position":"fixed","z-index":"700"} }
const _hoisted_9 = { style: {"background-color":"rgb(196, 197, 197)","margin-top":"7px","width":"600px"} }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  alt: "查询按钮",
  class: "element-plus-logo",
  src: _imports_1
}, null, -1)
const _hoisted_13 = ["src"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1)
const _hoisted_16 = { class: "common-layout" }

import { reactive, ref, onMounted, watch } from 'vue';//defineComponent toRefs
import { computed } from '@vue/reactivity';
import $http from '../http/index';
import { ElTable, ElMessage,DropdownInstance, ElTree } from 'element-plus';
import carModelSearch from '../components/CarModelSearch.vue';
import sizeSearch from '../components/SizeSearch.vue';
import baoYouLiangSearch from '../components/BaoYouLiangSearch.vue';
import productList from '../components/ProductList.vue';
import carModelList from '../components/CarModelList.vue';
import baoYouLiangList from '../components/BaoYouLiangList.vue';
import loginPage from '../components/LoginPage.vue';
import registPage from '../components/RegistPage.vue';
import editUserInfo from '../components/EditUserInfo.vue';
import {FrontEndUser} from '../Entity/UserInfo';
import $helper from '../helper/helper';
import {ButtonInfo} from '../Entity/pageButtonInfo';
import { useRoute } from 'vue-router';
import { el } from 'element-plus/es/locale';

interface SearchConditionDataTypeItem {
  icon: string,
  text: string,
  value: string
}
interface CodeSearchDTO{
  TypeCode:string,
  TypeCodeClassfy:string,
  GloryModel: string,
  GloryPartNumber: string,
  GloryModelGuid: string,//唯一
  ShowName:  string,
  ShowName2:  string,
  Position:string, // 安装位置
  ReplaceRemark: string,
  ProductSizes: string[],
  MapCode: string,
  PictureFileID:string,
  PictureFileURL:string,
  MiniPictureFileURL:string,
  LargePictureFileURL:string,
  ShowMoreProductInfo:boolean,
  ShowDetailProductInfo:boolean,
  Note:string,
  DevStatus:string,
  DevStatusText:string,
}
// 产品需求
interface ProductRequirement{
  ID:string,
  TypeCode:string,
  GloryModel:string,
  Position:string,
  OE:string,
  RequirementQty:string,
  CarBrand:string,
  CarModel:string,
  Remark:string,
  AnonymityID:string
}

interface CountryRegionInfo{
  Continent:string,//宏观地理区域中文
  ContinentEN:string,//宏观地理区域英文
  ContinentShotName:string,//宏观地理区域简写
  GeographyRegionName:string,//地理亚区中文
  GeographyRegionNameEN:string,//地理亚区英文
  GeographyRegionShortName:string,//地理亚区简写
  CountryRegionName:string,//国家中文
  CountryRegionNameEN:string,//国家英文
  Remark1:string,//KTYPE简写
}

interface TreeData {
  parentCode:string //父编码
  childCode:string //子编码
  label: string
  value:string
  children?: TreeData[]
  level:string //层级
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

class InitData {
  buttons: Array<ButtonInfo> = [
    //{ type: '', text: '国家', code: '', icon: '' , isShow: true},
    //{ type: '', text: '语言', code: '', icon: '' , isShow: true},
    { type: '', text: '登录', code: 'login', icon: '' , isShow: true},
    { type: '', text: '用户信息', code: 'loginUser', icon: '' , isShow: false},
    { type: '', text: '退出登录', code: 'logout', icon: '' , isShow: false},
  ]
  buttons2: Array<ButtonInfo> = [
    //{ type: '', text: '操作记录', code: 'operateRecord', icon: '' , isShow: true},
    //{ type: '', text: '退出登录', code: '', icon: '' },
    //{ type: '', text: '用户中心', code: '', icon: '' },
    { type: '', text: '新产品', code: 'newProduct', icon: '' , isShow: true},
    { type: '', text: '大盘片', code: 'bigProduct', icon: '' , isShow: true},
    { type: '', text: '改装片', code: 'refitProduct', icon: '' , isShow: true},
  ]
  carTypes: Array<ButtonInfo> = [
    { type: '', text: '乘用车', icon: require('../assets/images/carType1.png'), code: "ChengYongChe" , isShow: true},
    { type: '', text: '商用车', icon: require('../assets/images/carType2.png'), code: "ShangYongChe" , isShow: true},
    { type: '', text: '摩托车', icon: require('../assets/images/carType3.png'), code: "MoTuoChe" , isShow: true},
  ]
  productTypes: Array<ButtonInfo> = [
    { type: '', text: '刹车片', code: "BrakePads", icon: '' , isShow: true},
    { type: '', text: '刹车蹄', code: "BrakeShoe", icon: '' , isShow: true},
    { type: '', text: '报警线', code: "WarnLine", icon: '' , isShow: true},
    { type: '', text: '刹车盘', code: "BrakeDisc", icon: '' , isShow: true},
    { type: '', text: '刹车鼓', code: "BrakeDrum", icon: '' , isShow: true},
    { type: '', text: '手刹片', code: "HandBrake", icon: '' , isShow: true},
    { type: '', text: '刹车蹄组件', code: "BrakeKit", icon: '' , isShow: true},
    { type: '', text: '附件包', code: "AnnexPackge", icon: '' , isShow: true},
  ]
  searchTypeIcon: Array<ButtonInfo> = [
    { type: '', text: '附件包', code: "like", icon: require('../assets/images/image005.png') , isShow: true},
    { type: '', text: '附件包', code: "equals", icon: require('../assets/images/image006.png') , isShow: true},
  ]
  //查询条件下拉数据类型选项
  searchConditionDataTypeItems: Array<SearchConditionDataTypeItem> = [
    {
      icon: require('../assets/images/searchCondition6.png'),
      text: '按照任意编码搜索/直接拖入VIN图片',
      value: 'all'
    },
    {
      icon: require('../assets/images/searchCondition1.png'),
      text: '按照产品编码搜索',
      value: 'productCode'
    },
    {
      icon: require('../assets/images/searchCondition2.png'),
      text: '按照原厂零件号(OE)搜索',
      value: 'oeCode'
    },
    {
      icon: require('../assets/images/searchCondition3.png'),
      text: '按照其他零件号(FMSI/WVA...)搜索',
      value: 'otherCode'
    }, {
      icon: require('../assets/images/searchCondition4.png'),
      text: '按照产品状态编码(EAN/U9...)搜索',
      value: 'statusCode'
    },
    {
      icon: require('../assets/images/searchCondition5.png'),
      text: '按照车架号(VIN)搜索',
      value: 'vin'
    },
  ]
  companyLogoStyle = {
    height:'20px',
    width:'20px',
  }
  tableData:CodeSearchDTO[] = []
  tableDataShow:CodeSearchDTO[] = []
  tableDataSource = 'codeSearch'
  searchType = "like"//like:模糊查询 equals:精准查询 
  searchInput = ''
  checkedCarType = "ChengYongChe"//车辆类型 ChengYongChe:乘用车 ShangYongChe:商用车 MoTuoChe:摩托车
  checkProductTypes: Array<string> = []//产品类型选中
  checkedsearchConditionDataTypeItem: SearchConditionDataTypeItem = {
    icon: require('../assets/images/searchCondition6.png'),
    text: '按照任意编码搜索/直接拖入VIN图片',
    value: 'all'
  }
  pageIndex = 1
  loading = false
  showTable = false
  matchCarModel = ref<InstanceType<typeof ElTable>>()
  isOperateSearch = false //是否执行过查询操作
  baseCompanyLogoUrl = require('../assets/images/glory.png')
  companyLogoUrl = require('../assets/images/glory.png')     
  anonymityID='' //匿名ID
  productRequirements:Array<ProductRequirement>=[] //产品需求
  isCarModelSearchPage=false //显示车型查询
  isShowSizeSearchPage=false //显示尺寸查询页
  isBaoYouLiangSearchPage=false //显示保有量查询
  carModelSearchButton=false //车型查询按钮是否点击
  sizeSearchButton=false //尺寸查询按钮是否点击
  baoYouLiangSearchButton=false //保有量查询按钮是否点击
  sizeSearchClassify = 'BrakePads' //尺寸查询条件类别
  showListType=""
  carModelSearchData='' //车型查询结果数据
  carModelSearchDataTotalMsg='' //车型查询结果汇总数据
  baoYouLiangSearchParam = ''// 保有量查询参数
  baoYouLiangSearchData='' //保有量查询结果数据
  baoYouLiangSearchDataTotalMsg='' //保有量查询结果汇总数据
  isShowlogin=false //显示登录页面
  nationalRegion='' //国家地区数据
  nationalRegionName='' //国家地区名
  showNationalRegionName='' //显示的国家地区名
  nationalRegionData:TreeData[]=[]
  nationalRegionFilterText='' //国家地区树过滤文本
  loginUser:FrontEndUser={ //当前登录用户Data
    ID:'',
    Brand:'',
    Account:''
  }
  buttonStyle1='padding-left: 3px;padding-right: 3px;background-color:transparent;float:right;margin-left:8px'
  buttonStyle2='padding-left: 3px;padding-right: 3px;background-color:#F00;float:right;margin-left:8px'
  isShowRegist=false //显示注册页面
  isShowEditUser=false //显示用户信息修改
  editUserPageID="" //修改用户信息的ID
  productTypeElementStyle='margin-left:0px;overflow-y:hidden'
  codeSearchHistories:Array<string>=[] //编码查询历史
  isShowCodeHistory=false
  newProductTime='|';
  bodyWrapStyle={ //body元素样式
    'background-color':'black',
    'width':'1200px',
    'margin':'0px auto'
  }
  navigateHeaderStyle={ //导航样式
    'background-color':'black',
    'width':'1200px',
    'left':'0%',
    'right':'0%',
    'margin':'0px auto',
  }
  opetateClassifyStyle={ //操作分类样式
    'background-color':'#555555',
    'margin':'0 5px',
    'padding-left':'0px'
  }
  searchLogo1Style={
    'width': '100%',
    'height': '40px',
    'background-color': '#F00',
    'border-radius': '5px 0 0 5px;',
    'cursor': 'pointer'
  }
  searchLogo4Style={
    'height':'40px',
    'background-color':'#F00',
    'border-radius':'0 5px 5px 0',
    'cursor':'pointer'
  }
  carTypesCheckedStyle='background-color:FF0000'
  checkProductTypesCheckedStyle={
    'background-color':'#F00',
    'padding-left': '8px',
    'padding-right':'8px'
  }
  checkProductTypesUnCheckStyle={
    'padding-left': '8px',
    'padding-right':'8px'
  }
  fontStyle={
    'color':'#DDD'
  }
}

const data = reactive(new InitData());
const vinFileInput = ref<null | HTMLInputElement>(null)
const nationalRegionRef = ref<DropdownInstance>()
const nationalRegionTreeRef = ref<InstanceType<typeof ElTree>>()
const searchTypeChange = () => {
  if (data.searchType == "like") {
    data.searchType = "equals";
  } else if (data.searchType == "equals") {
    data.searchType = "like";
  }
}
//查询条件的数据类型
const searchConditionDataType = (command: string | number | object) => {
  for (let i = 0; i < data.searchConditionDataTypeItems.length; i++) {
    let item = data.searchConditionDataTypeItems[i];
    if (item.value == command) {
      data.checkedsearchConditionDataTypeItem = item;
    }
  }
}
const checkProductTypeEvent = (code: string) => {
  let index = data.checkProductTypes.indexOf(code);
  if (index > -1) {
    data.checkProductTypes.splice(index, 1);
  } else {
    data.checkProductTypes.push(code);
  }
}

/**
 * 主页面查询操作
 */
const searchOperate = () => {
  let searchInputTemp = data.searchInput;
  for(let i=0;i<100;i++){
    searchInputTemp = searchInputTemp.replaceAll(",","").replaceAll("_","").replaceAll("-","").replaceAll("/","").replaceAll(" ","").replaceAll("\t","");
  }
  data.showListType=''
  data.tableDataSource = 'codeSearch'
  data.isShowSizeSearchPage=false;// 隐藏尺寸查询页面
  data.isCarModelSearchPage=false;// 隐藏车型查询页面
  data.isBaoYouLiangSearchPage=false;// 隐藏保有量查询页面
  data.carModelSearchButton=false;
  data.baoYouLiangSearchButton=false;
  data.searchInput = searchInputTemp;
  data.showTable = true;
  data.pageIndex = 1;
  data.loading = true;
  data.matchCarModel?.scrollTo(0, 0);
  $http({
    url: "/API/Product/ProductSearch",
    method: "POST",
    data: {
      searchConditionDataType: data.checkedsearchConditionDataTypeItem.value,
      searchType: data.searchType,
      searchInput: data.searchInput,
    }
  }).then(res => {
    data.isOperateSearch  = true;
    data.tableData = res.data || [];
    SetCheckProductTypes(data.tableData);
    if(data.tableData && data.tableData.length>0){
      setCodeSearchHistories(data.searchInput);
    }
  }).finally(() => {
    window.setTimeout(() => {
      data.loading = false
    }, 500);
  })
}

/**
 * 设置显示的产品类型
 * @param showDatas 
 */
const SetCheckProductTypes = (showDatas:Array<CodeSearchDTO>)=>{
  data.checkProductTypes = [];
  for(let i=0;showDatas && i<showDatas.length;i++){
    showDatas[i].TypeCodeClassfy = showDatas[i].TypeCode;
    if(showDatas[i].TypeCode == "ParkingBrakeShoe"){
      showDatas[i].TypeCodeClassfy = "BrakeShoe";//驻车刹车蹄
    }
    let typeCodeClassfy = showDatas[i].TypeCodeClassfy;
    if(typeCodeClassfy && data.checkProductTypes.findIndex(c=>c==typeCodeClassfy)<0){
        data.checkProductTypes.push(typeCodeClassfy)
      }
  }
}

const imageParse = (file: File) => {
  if (!file) return;
  ElMessage({
    showClose: false,
    message: '图片识别中..',
  })
  $helper.fileUpload(file,"ImageParseVin",'',function(vin){
    data.searchInput = vin;
    searchOperate();
  })
}
const vinFileClick = () => {
  vinFileInput?.value?.dispatchEvent(new MouseEvent("click"))
}
//文件拖拽事件处理
const imageDrop = (e: DragEvent) => {
  e.preventDefault();
  let file = e.dataTransfer?.files[0]
  if (!file) return;
  if (file.type.startsWith("image")) {
    imageParse(file);
  } else {
    ElMessage.error("只能处理图片");
  }
}
const vinFileChange = (e: Event) => {
  const target = e.target as HTMLInputElement
  const files = target.files
  if (files) {
    const uploadedFile = files[0]
    imageParse(uploadedFile)
  }
}
const searchTypeIconShow = computed(() => {
  let icon = "";
  for (let i = 0; i < data.searchTypeIcon.length; i++) {
    if (data.searchTypeIcon[i].code == data.searchType) {
      icon = data.searchTypeIcon[i].icon;
      break;
    }
  }
  return icon;
});

const route = useRoute();

onMounted(() => {
  
  //保存域名到缓存
  const hostName = window.location.host;
  const domainName = hostName.split(':')[0];
  window.localStorage.setItem("domainName",domainName);
  window.localStorage.setItem("vueAppBaseApi",process.env.VUE_APP_BASE_API);
  
  const brandDecoration = $helper.getBrandDecoration();
  data.bodyWrapStyle['background-color']=`#${brandDecoration.MainBackColor}`
  data.navigateHeaderStyle['background-color']=`#${brandDecoration.MainBackColor}`

  //公司图片logo
  if(brandDecoration.ShowBrandPicture){
    data.companyLogoUrl = `${process.env.VUE_APP_BASE_API}/API/Product/GetPictute?folderId=${brandDecoration.ShowBrandPicture}`
  }else{
    data.companyLogoUrl = data.baseCompanyLogoUrl;
  }

  //条形框颜色
  if(brandDecoration.BarColor){
    data.opetateClassifyStyle['background-color']=`#${brandDecoration.BarColor}`;
  }

  //查询按钮样式
  if(brandDecoration.BrandInputColor){
    data.searchLogo1Style['background-color']=`#${brandDecoration.BrandInputColor}`;
    data.searchLogo4Style['background-color']=`#${brandDecoration.BrandInputColor}`;
    data.carTypesCheckedStyle=`background-color:#${brandDecoration.BrandInputColor}`;
    data.checkProductTypesCheckedStyle['background-color']=`#${brandDecoration.BrandInputColor}`;
    data.buttonStyle2=`padding-left: 3px;padding-right: 3px;background-color:#${brandDecoration.BrandInputColor};float:right;margin-left:8px`;
  }
  
  //车型类别
  if(brandDecoration.CarTypes){
    const types = brandDecoration.CarTypes.split(',')
    for(let i=0;i<data.carTypes.length;i++){
      const index = types.findIndex(c=>c==data.carTypes[i].code);
      if(index<0){
        data.carTypes[i].isShow=false;
      }
    }
  }

  //产品类别
  if(brandDecoration.ProductTypes){
    const types = brandDecoration.ProductTypes.split(',')
    const showProductTypes:Array<ButtonInfo> =[];
    for(let i=0;i<data.productTypes.length;i++){
      const index = types.findIndex(c=>c==data.productTypes[i].code);
      if(index>-1){
        showProductTypes.push(data.productTypes[i])
      }
    }
    data.productTypes = showProductTypes;
  }

  //文字颜色
  if(brandDecoration.FontColor){
    data.fontStyle.color=`#${brandDecoration.FontColor}`;
  }

  refreshLoginInfo();
  logoadapter();
  setProductTypeElementStyle();
  window.onresize = () => {
    logoadapter();
    window.setTimeout(function(){
      logoadapter();
    },200);
  }

  window.setTimeout(function(){
    setProductTypeElementStyle();
  },500);

  // 滚动条到底部刷新表格数据 暂时不要删除
  // let dom = document.querySelector(".el-scrollbar__wrap");
  // dom?.addEventListener("scroll", () => {
  //   if (data.loading == true) {
  //     return;
  //   }
  //   if (dom != null) {
  //     const scrollDistance = dom.scrollHeight - dom.scrollTop - dom.clientHeight;
  //     // 判断是否到底，可以加载下一页
  //     if (scrollDistance <= 1) {
  //       data.pageIndex++
  //       data.loading = true;
  //       $http({
  //         url: "/API/Product/SearchCarModelsInfoMatch",
  //         method: "POST",
  //         data: {
  //           searchConditionDataType: data.checkedsearchConditionDataTypeItem.value,
  //           searchType: data.searchType,
  //           searchInput: data.searchInput,
  //           pageIndex: data.pageIndex,
  //           checkProductTypes: data.checkProductTypes.toString()
  //         }
  //       }).then(res => {
  //         let data2: [] = res.data || [];
  //         for (let i = 0; i < data2.length; i++) {
  //           data.tableData.push(data2[i])
  //         }
  //       }).finally(() => {
  //         data.loading = false;
  //       })
  //     }
  //   }
  // });

  let anonymityID = localStorage.getItem("anonymityID");//匿名ID
  if(!anonymityID){
    anonymityID = $helper.createID();
    localStorage.setItem("anonymityID",anonymityID)
  }
  data.anonymityID = anonymityID;
  // 产品需求
  getProductRequirement();
  // 添加访问记录
  addAccessRecord();
  //编码查询历史
  setCodeSearchHistories('');
  //自动登录
  loginByToken();
  //国家
  getNationalRegionData();
})

// 适配公司图标的位置和大小
const logoadapter = ()=>{ 
  let maxWidth = 100;
  let maxHeight = 50;
  let homeCompanyLogoWrap = document.getElementById('homeCompanyLogoWrap');
  let row121 = document.getElementById('row121');
  let row122 = document.getElementById('row122');
  if(homeCompanyLogoWrap!=null && row121 && row122){
    maxWidth = homeCompanyLogoWrap.clientWidth;
    maxHeight = row121.clientHeight + row122.clientHeight;
  }
  data.companyLogoStyle.width=`${maxWidth}px`; 
  data.companyLogoStyle.height=`${maxHeight}px`; 
  // data.companyLogoStyle.width=`${maxWidth-5}px`; 
  // data.companyLogoStyle.height=`${maxHeight-5}px`; 
}

/**
 * 打开产品需求页面
 */
const openProductRequirement = ()=>{
  $helper.openNewPage('/productRequirement')
}

/**
 * 获取产品需求
 */
const getProductRequirement=()=>{
  $http({
    url: `/API/Product/GetProductRequirement?anonymityID=${data.anonymityID}`,
    method: "GET",
    data: {}
  }).then(res => {
    data.productRequirements = res.data || [];
  });
}

const gotoHome = ()=>{
  // 一次对比
  window.localStorage.setItem("addOrRemoveCompareProduct",JSON.stringify([]));
  // 移除产品需求
  $http({
    url: `/API/Product/RemoveAllProductRequirement?anonymityID=${data.anonymityID}`,
    method: "post",
    data: {}
  }).then(() => {
    data.productRequirements = [];
    window.location.reload();
  });
}


const updatedProductRequirement=(requirementStr:string)=>{
  data.productRequirements = JSON.parse(requirementStr);
}

/**
 * 尺寸查询
 */
const sizeSearchPage = ()=>{
  data.showListType=''
  data.carModelSearchButton=false;//不是车型查询
  data.isCarModelSearchPage=false;//不是车型查询
  data.baoYouLiangSearchButton=false;//不是保有量查询
  data.isBaoYouLiangSearchPage=false;//不是保有量查询
  data.sizeSearchButton=!data.sizeSearchButton;
  data.isShowSizeSearchPage = data.sizeSearchButton;
  data.isOperateSearch = false;
  data.tableData = [];
}

/**
 * 展示尺寸查询结果
 * @param resultData 
 */
const showSizeSearchData =(resultData:string,sizeSearchClassify:string)=>{
  data.tableDataSource = 'sizeSearch'
  data.sizeSearchClassify = sizeSearchClassify;
  data.isShowSizeSearchPage = false;
  data.tableData = JSON.parse(resultData);
  let sizeSearchCondition = JSON.parse(JSON.stringify({TypeCode:'sizeSearchCondition'}))
  data.tableData.unshift(sizeSearchCondition);
  SetCheckProductTypes(data.tableData);
}

/**
 * 车型查询 
 */
const carModelSearchPage= ()=>{
  data.showListType='carModelList'
  data.sizeSearchButton=false;//不是尺寸查询
  data.isShowSizeSearchPage=false;//不是尺寸查询
  data.baoYouLiangSearchButton=false;//不是保有量查询
  data.isBaoYouLiangSearchPage=false;//不是保有量查询
  
  data.carModelSearchButton=!data.carModelSearchButton;
  data.isCarModelSearchPage = data.carModelSearchButton;
  data.isOperateSearch = false;
  if(data.carModelSearchButton){
    //默认显示 刹车片 刹车蹄
    data.checkProductTypes = ['BrakePads','BrakeShoe'];
  }
  if(!data.carModelSearchButton){
    data.showListType=''
  }
  data.carModelSearchData='[]';
  data.carModelSearchDataTotalMsg = '';
}

/**
 * 保有量查询
 */
const baoYouLiangSearchPage= ()=>{
  data.showListType='baoYouLiangList'
  data.carModelSearchButton=false;//不是车型查询
  data.isCarModelSearchPage=false;//不是车型查询
  data.sizeSearchButton=false;//不是尺寸查询
  data.isShowSizeSearchPage=false;//不是尺寸查询
  
  data.baoYouLiangSearchButton=!data.baoYouLiangSearchButton;
  data.isBaoYouLiangSearchPage = data.baoYouLiangSearchButton;
  data.isOperateSearch = false;
  if(data.baoYouLiangSearchButton){
    //默认显示 刹车片 刹车蹄
    data.checkProductTypes = ['BrakePads','BrakeShoe'];
  }
  if(!data.baoYouLiangSearchButton){
    data.showListType=''
  }
  data.baoYouLiangSearchData='[]';
  data.baoYouLiangSearchDataTotalMsg = '';
}

const showCarModelSearchData=(resultData:string)=>{
  data.carModelSearchData = resultData;
}

const showBaoYouLiangSearchData=(resultData:string,searchParam:string)=>{
  data.baoYouLiangSearchData = resultData;
  data.baoYouLiangSearchParam = searchParam;
}


const showCarModelSearchDataTotalMsg=(totalMsg:string)=>{
  data.carModelSearchDataTotalMsg=totalMsg;
}

const showBaoYouLiangSearchDataTotalMsg=(totalMsg:string)=>{
  data.baoYouLiangSearchDataTotalMsg=totalMsg;
}

/**
 * 查询中
 */
const searching = ()=>{
  data.loading = true;
  console.log("searching "+data.loading)
}

/**
 * 查询结束
 */
const searched = ()=>{
  data.loading = false;
}

/**
 * 头部按钮被点击
 * @param code 按钮编码
 */
const headerButtonClick = (code:string)=>{
  switch(code){
    //case "goNationalRegionSelect":goNationalRegionSelect();break;
    case "login":login();break;
    case "logout":logout();break;
    case "loginUser":editUser();break;
  }
}

const login=()=>{
  data.isShowlogin=true;
}

/**
 * 通过Token登录
 */
const loginByToken=()=>{
  let queryParams = getQueryParams();
  if(!queryParams || !queryParams.token){
    return;
  }
  $http({
        url: `/API/FrontEndUser/LoginByToken?token=${queryParams.token}`,
        method: "get",
        data: {}
    }).then(res => {
        window.localStorage.setItem("userInfo",JSON.stringify(res.data));
        loginComplete();
    });
}

const getQueryParams=()=>{
  let index = window.location.href.indexOf('?');
  let params:any = {};
  if(index>-1){
    const queryString = window.location.href.substring(index+1);
    queryString.split('&').forEach(pair => {
      const [key, value] = pair.split('=');
      params[decodeURIComponent(key)] = decodeURIComponent(value || '');
    });
  }
  return params;
}

const logout=()=>{
  window.localStorage.setItem('userInfo','');
  data.loginUser.ID='';
  data.loginUser.Account='';
  data.loginUser.Brand='';
  refreshLoginInfo();
  location.reload();
}

/**
 * 登录完成
 */
const loginComplete=()=>{
  data.isShowlogin=false;
  refreshLoginInfo();
  //如果URL携带Token,就需要去掉，防止重复刷新
  let params = getQueryParams();
  if( params && params["token"]){
    let index = window.location.href.indexOf('?');
    let rootUrl = window.location.href.substring(0,index);
    window.location.href = rootUrl;
  }
  location.reload();
}

/**
 * 跳转注册弹窗
 */
const gotoRegist=()=>{
  data.isShowlogin=false;
  data.isShowRegist=true;
}

/**
 *  注册完成
 */
const registComplete=()=>{
  data.isShowlogin=true;
  data.isShowRegist=false;
  location.reload();
}

/**
 * 编辑用户信息
 */
const editUser=()=>{
  if(!data.editUserPageID){
    window.setTimeout(function(){
      data.editUserPageID = $helper.createID();
    },500);
  }
  data.editUserPageID = $helper.createID();
  data.isShowEditUser=true;
  location.reload();
}

/**
 * 编辑用户信息
 */
const editUserComplete=()=>{
  data.isShowEditUser=false;
  refreshLoginInfo();
  location.reload();
}

/**
 * 回到首页
 */
const goHome=()=>{
  data.isShowlogin=false;
  data.isShowRegist=false;
}

/**
 * 刷新登录用户信息
 */
const refreshLoginInfo=()=>{
  const userInfoJson = window.localStorage.getItem("userInfo");
  if(userInfoJson){
    data.loginUser = JSON.parse(userInfoJson);
    const index =  data.buttons.findIndex(c=>c.code=='loginUser');
    if(index>-1){
      data.buttons[index].text = data.loginUser.Account;
    }
  }
  else{
    data.loginUser.ID='';
    data.loginUser.Account='';
    data.loginUser.Brand='';
  }

  if(data.loginUser.ID){
    const loginIndex = data.buttons.findIndex(c=>c.code=='login');
    data.buttons[loginIndex].isShow = false;

    const loginUserIndex = data.buttons.findIndex(c=>c.code=='loginUser');
    data.buttons[loginUserIndex].text = data.loginUser.Account;
    data.buttons[loginUserIndex].isShow = true;

    const logoutIndex = data.buttons.findIndex(c=>c.code=='logout');
    data.buttons[logoutIndex].isShow = true;
  }else{
    const loginIndex = data.buttons.findIndex(c=>c.code=='login');
    data.buttons[loginIndex].isShow = true;

    const loginUserIndex = data.buttons.findIndex(c=>c.code=='loginUser');
    data.buttons[loginUserIndex].isShow = false;

    const logoutIndex = data.buttons.findIndex(c=>c.code=='logout');
    data.buttons[logoutIndex].isShow = false;
  }
}

/**
 * 查询条件
 */
const searchConditionDataTypeItemsShow = computed(()=>{
  const items:Array<SearchConditionDataTypeItem> = [];
  for(let i=0;i<data.searchConditionDataTypeItems.length;i++){
    let item = data.searchConditionDataTypeItems[i];
    if(item.value=="all"){
      items.push(item);
      continue;
    }
    if($helper.hasPermission(item.value)){
      items.push(item);
    }
  }
  return items;
})

const topRightButtions = computed(()=>{
  const items:Array<ButtonInfo> = [];
  for(let i=0;i<data.buttons2.length;i++){
    let item = data.buttons2[i];
    if($helper.hasPermission(item.code)){
      items.push(item);
    }
  }
  return items;
});

const setLanguages = (command:string)=>{
  window.localStorage.setItem('lanType',command);
  location.reload();
}

const setProductTypeElementStyle=()=>{
  const elements = document.getElementsByClassName("productTypeElement");
  let width = 0;
  for (let i = 0; i < elements.length; i++) {
    width += elements[i].clientWidth;
  }
  let left = (839-width)/2;
  data.productTypeElementStyle = `margin-left:${left}px;overflow-y:hidden`;
}

/**
 * 添加访问记录
 */
const addAccessRecord=()=>{
  $http({
    url: `/API/Product/AddAccessRecord`,
    method: "post",
    data: {
      userID:data.anonymityID
    }
  });
}

/**
 * 设置编码查询历史
 * @param code 
 */
const setCodeSearchHistories = (code:string)=>{
  let codeSearchHistories:Array<string> = [];
  if(code){
    codeSearchHistories.push(code);
  }
  const codeSearchHistoriesJson = window.localStorage.getItem("codeSearchHistories");
  if(codeSearchHistoriesJson!=null){
    const cacheData:Array<string> = JSON.parse(codeSearchHistoriesJson);
    for(let i=0;cacheData&&i<cacheData.length;i++){
      if(codeSearchHistories.indexOf(cacheData[i])>-1)continue;
      codeSearchHistories.push(cacheData[i]);
    }
  }
  if(codeSearchHistories.length>9){
    codeSearchHistories = codeSearchHistories.slice(0,9)
  }
  data.codeSearchHistories = codeSearchHistories;
  window.localStorage.setItem("codeSearchHistories",JSON.stringify(data.codeSearchHistories));
}

const showCodeHistory = ()=>{
  data.isShowCodeHistory=true
};

const hideCodeHistory = ()=>{
  window.setTimeout(function(){
    data.isShowCodeHistory=false
  },300);
};

/**
 * 编码查询历史点击处理
 * @param code 
 */
const codeHistoryClick =(code:string)=>{
  data.searchInput =code;
  searchOperate();
}

/**
 * 右上角按钮点击处理
 */
const topRightButtionClick=(buttonCode:string)=>{
  console.log(buttonCode);
  if(buttonCode=="newProduct"){
    newProductSearchOperate();
  }
  if(buttonCode=="bigProduct"){
    bigProductSearchOperate();
  }
  if(buttonCode=="refitProduct"){
    refitProductSearchOperate();
  }
}

/**
 * 新品查看操作
 */
const newProductSearchOperate = () => {
  data.showListType=''
  data.tableDataSource = 'newProductSearch'
  data.isShowSizeSearchPage=false;// 隐藏尺寸查询页面
  data.isCarModelSearchPage=false;// 隐藏车型查询页面
  data.isBaoYouLiangSearchPage=false;// 隐藏保有量查询页面
  data.carModelSearchButton=false;
  data.baoYouLiangSearchButton=false;
  data.isOperateSearch = false;
  data.tableData = [];
  data.showTable = true;
  data.pageIndex = 1;
  data.loading = true;
  data.matchCarModel?.scrollTo(0, 0);

  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = ("0" + (now.getMonth() + 1)).slice(-2); 
  const endTime = `${currentYear}-${currentMonth}-01`
  now.setMonth(now.getMonth() - 1);
  const startTime = `${now.getFullYear()}-${("0" + (now.getMonth() + 1)).slice(-2)}-01`
  data.newProductTime=`${startTime}|${endTime}|${$helper.createID()}`;
  window.setTimeout(function(){
    data.newProductTime=`${startTime}|${endTime}|${$helper.createID()}`;
  },1000);
  $http({
    url: "/API/Product/GetNewProducts",
    method: "POST",
    data: {
      startTime: startTime,
      endTime: endTime,
    }
  }).then(res => {
    data.isOperateSearch  = true;
    data.tableData = res.data || [];
    let newProductSearchCondition = JSON.parse(JSON.stringify({TypeCode:'newProductSearchCondition'}))
    data.tableData.unshift(newProductSearchCondition);
    SetCheckProductTypes(data.tableData);
  }).finally(() => {
    window.setTimeout(() => {
      data.loading = false
    }, 500);
  })
}

/**
 * 大盘片查看操作
 */
const bigProductSearchOperate = () => {
  data.showListType=''
  data.tableDataSource = 'bigProductSearch'
  data.isShowSizeSearchPage=false;// 隐藏尺寸查询页面
  data.isCarModelSearchPage=false;// 隐藏车型查询页面
  data.isBaoYouLiangSearchPage=false;// 隐藏保有量查询页面
  data.carModelSearchButton=false;
  data.baoYouLiangSearchButton=false;
  data.isOperateSearch = false;
  data.tableData = [];
  data.showTable = true;
  data.pageIndex = 1;
  data.loading = true;
  data.matchCarModel?.scrollTo(0, 0);
  $http({
    url: "/API/Product/GetBigProducts",
    method: "POST",
    data: {}
  }).then(res => {
    data.isOperateSearch  = true;
    window.setTimeout(function(){
      data.tableData = res.data || [];
      SetCheckProductTypes(data.tableData);
    },300);
  }).finally(() => {
    window.setTimeout(() => {
      data.loading = false
    }, 500);
  })
}

const refitProductSearchOperate=()=>{
  data.showListType=''
  data.tableDataSource = 'refitProductSearch'
  data.isShowSizeSearchPage=false;// 隐藏尺寸查询页面
  data.isCarModelSearchPage=false;// 隐藏车型查询页面
  data.isBaoYouLiangSearchPage=false;// 隐藏保有量查询页面
  data.carModelSearchButton=false;
  data.baoYouLiangSearchButton=false;
  data.isOperateSearch = false;
  data.tableData = [];
  data.showTable = true;
  data.pageIndex = 1;
  data.loading = true;
  data.matchCarModel?.scrollTo(0, 0);
  $http({
    url: "/API/Product/GetFefitProducts",
    method: "POST",
    data: {}
  }).then(res => {
    data.isOperateSearch  = true;
    window.setTimeout(function(){
      data.tableData = res.data || [];
      SetCheckProductTypes(data.tableData);
    },300);
  }).finally(() => {
    window.setTimeout(() => {
      data.loading = false
    }, 500);
  })
}

/**
 * 展示新品查询结果
 * @param resultData 
 */
const showNewProductSearchData =(resultData:string)=>{
  data.tableDataSource = 'newProductSearch'
  data.tableData = JSON.parse(resultData);
  let newProductSearchCondition = JSON.parse(JSON.stringify({TypeCode:'newProductSearchCondition'}))
  data.tableData.unshift(newProductSearchCondition);
  SetCheckProductTypes(data.tableData);
}

/**
 * 获取国家信息
 */
const getNationalRegionData=()=>{
  $http({
    url: "/API/Product/GetNationalRegionData",
    method: "POST",
    data: {}
  }).then(res => {
    data.nationalRegion=window.localStorage.getItem("nationalRegion")??'';
    let allCountry = res.data as CountryRegionInfo[];
    let lanType = window.localStorage.getItem('lanType');
    if(!lanType)lanType='CN';//默认中文
    let regionKeyGet = function(baseinfo:CountryRegionInfo){
      //区域简写会跨大洲重复（如 EA 既是"东亚"也是"东非"）
        return `Region_${baseinfo.GeographyRegionName}`;//${baseinfo.GeographyRegionShortName}_
    }
    let continentKeyGet = function(baseinfo:CountryRegionInfo){
        return `Continent_${baseinfo.Continent}`;//${baseinfo.ContinentShotName}_
    }
    let nations:TreeData[]=[];//国家
    for(let i=0;i<allCountry.length;i++){
      if(!allCountry[i].Remark1)continue;
      nations.push( {
        parentCode : regionKeyGet(allCountry[i]),
        childCode : allCountry[i].Remark1,
        value : allCountry[i].Remark1,
        label : lanType!="CN"?allCountry[i].CountryRegionNameEN: allCountry[i].CountryRegionName,
        children:[],
        level:'国家'
      });
      if(allCountry[i].Remark1==data.nationalRegion){
        data.nationalRegionName=lanType!="CN"?allCountry[i].CountryRegionNameEN: allCountry[i].CountryRegionName;
        if(data.nationalRegionName){
          data.showNationalRegionName=data.nationalRegionName;
          window.localStorage.setItem("nationalRegionName",data.nationalRegionName);
        } else {
          data.showNationalRegionName=$helper.lan('国家');
        }
      }
      if(data.nationalRegion=='all'){
        data.nationalRegionName=$helper.lan('全部');
        data.showNationalRegionName=$helper.lan('全部');
      }
    }
    let regions:TreeData[]=[];//区域
    for(let i=0;i<allCountry.length;i++){
      if(!allCountry[i].GeographyRegionShortName)continue;
      if(regions.findIndex(c=>c.childCode==regionKeyGet(allCountry[i]))>-1)continue;
      regions.push( {
        parentCode : continentKeyGet(allCountry[i]),
        childCode : regionKeyGet(allCountry[i]),
        value : regionKeyGet(allCountry[i]),
        label : lanType!="CN"?allCountry[i].GeographyRegionNameEN: allCountry[i].GeographyRegionName,
        children:nations.filter(c=>c.parentCode==regionKeyGet(allCountry[i])),
        level:'区域'
      });
    }
    let continents:TreeData[]=[];//大洲
    for(let i=0;i<allCountry.length;i++){
      if(!allCountry[i].ContinentShotName)continue;
      if(continents.findIndex(c=>c.childCode==continentKeyGet(allCountry[i]))>-1)continue;
      continents.push( {
        parentCode : '',
        childCode : continentKeyGet(allCountry[i]),
        value : continentKeyGet(allCountry[i]),
        label : lanType!="CN"?allCountry[i].ContinentEN:allCountry[i].Continent,
        children:regions.filter(c=>c.parentCode==continentKeyGet(allCountry[i])),
        level:'大洲'
      });
    }
    continents.push( {
        parentCode : '',
        childCode : 'all',
        value : 'all',
        label : $helper.lan('全部'),
        children:[],
        level:'国家'
    });
    data.nationalRegionData=continents;
    data.nationalRegionName=window.localStorage.getItem("nationalRegionName")??'';
    if(!data.nationalRegionName){
      data.showNationalRegionName=$helper.lan('国家');
    } else if(!data.showNationalRegionName){
      //多选存储的是逗号拼接的编码，不会与单个国家匹配，取缓存的选择名称展示
      data.showNationalRegionName=data.nationalRegionName;
    }
  }).finally(() => {
    console.log('获取国家信息');
  })
}

/**
 * 国家/地区树勾选：取叶子（国家）节点，编码逗号拼接后存储
 */
const handleNationalRegionCheck = ()=>{
  const tree = nationalRegionTreeRef.value;
  if(!tree)return;
  const nations = tree.getCheckedNodes(true) as unknown as TreeData[];
  const values = nations.map(c=>c.value).filter(v=>v);
  //按钮只展示一个选中的国家
  let showName = nations.length>0 ? nations[0].label : '';
  if(nations.length>1){
    showName = showName+`+${nations.length-1}`;
  }
  window.localStorage.setItem("nationalRegion",values.join(','));
  window.localStorage.setItem("nationalRegionName",showName);
  data.nationalRegion=values.join(',');
  data.nationalRegionName=showName;
  data.showNationalRegionName=showName || $helper.lan('国家');
}

/**
 * 下拉展开时回填已勾选的国家
 */
const handleNationalRegionVisible = (visible:boolean)=>{
  if(!visible)return;
  const values = (data.nationalRegion || '').split(',').filter(c=>c);
  window.setTimeout(()=>{
    nationalRegionTreeRef.value?.setCheckedKeys(values);
  },0);
}

/**
 * 国家/地区树过滤：按节点名称匹配
 */
const nationalRegionFilterNode = (value:string, nodeData:TreeData)=>{
  if(!value)return true;
  const label = nodeData.label || '';
  return label.toLowerCase().indexOf(value.trim().toLowerCase())>-1;
}

/**
 * 过滤文本变化时过滤国家/地区树
 */
watch(
  ()=>data.nationalRegionFilterText,
  (value)=>{
    nationalRegionTreeRef.value?.filter(value);
  }
)


return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(carModelSearch, {
      isShowInput: data.isCarModelSearchPage,
      onShowCarModelSearchData: showCarModelSearchData,
      onShowCarModelSearchDataTotalMsg: showCarModelSearchDataTotalMsg,
      onSearching: searching,
      onSearched: searched
    }, null, 8, ["isShowInput"]),
    _createVNode(sizeSearch, {
      isShowInput: data.isShowSizeSearchPage,
      onShowSizeSearchData: showSizeSearchData,
      onSearching: searching,
      onSearched: searched
    }, null, 8, ["isShowInput"]),
    _createVNode(baoYouLiangSearch, {
      isShowInput: data.isBaoYouLiangSearchPage,
      onShowBaoYouLiangSearchData: showBaoYouLiangSearchData,
      onShowBaoYouLiangSearchDataTotalMsg: showBaoYouLiangSearchDataTotalMsg,
      onSearching: searching,
      onSearched: searched
    }, null, 8, ["isShowInput"]),
    _createVNode(_component_el_dialog, {
      class: "showloginHead",
      modelValue: data.isShowlogin,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.isShowlogin) = $event)),
      "show-close": false,
      width: "400px",
      "align-center": true
    }, {
      default: _withCtx(() => [
        _createVNode(loginPage, {
          onLoginComplete: loginComplete,
          onGotoRegist: gotoRegist
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      class: "showloginHead",
      modelValue: data.isShowRegist,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.isShowRegist) = $event)),
      "show-close": false,
      width: "400px",
      "align-center": true
    }, {
      default: _withCtx(() => [
        _createVNode(registPage, {
          onRegistComplete: registComplete,
          onGoHome: goHome
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      class: "showloginHead",
      modelValue: data.isShowEditUser,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.isShowEditUser) = $event)),
      "show-close": false,
      width: "400px",
      "align-center": true
    }, {
      default: _withCtx(() => [
        _createVNode(editUserInfo, {
          editUserPageID: data.editUserPageID,
          onEditUserComplete: editUserComplete,
          onGoHome: goHome
        }, null, 8, ["editUserPageID"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", {
      class: "bodyWrap",
      style: _normalizeStyle(data.bodyWrapStyle)
    }, [
      _createElementVNode("div", {
        class: "navigateHeader",
        style: _normalizeStyle(data.navigateHeaderStyle)
      }, [
        _createVNode(_component_el_row, { gutter: 5 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 5 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_el_image, {
                    style: _normalizeStyle(data.companyLogoStyle),
                    src: data.companyLogoUrl,
                    fit: "fill"
                  }, null, 8, ["style", "src"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 19 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, { id: "row121" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_dropdown, {
                          ref_key: "nationalRegionRef",
                          ref: nationalRegionRef,
                          "max-height": "300",
                          onVisibleChange: handleNationalRegionVisible,
                          style: {"margin-top":"8px","margin-right":"10px"}
                        }, {
                          dropdown: _withCtx(() => [
                            _createElementVNode("div", {
                              style: {"padding":"8px 8px 0 8px","min-width":"200px"},
                              onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                            }, [
                              _createVNode(_component_el_input, {
                                modelValue: data.nationalRegionFilterText,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.nationalRegionFilterText) = $event)),
                                size: "small",
                                clearable: "",
                                autocomplete: "new-password",
                                spellcheck: "false",
                                placeholder: _unref($helper).lan('搜索国家/地区')
                              }, null, 8, ["modelValue", "placeholder"])
                            ]),
                            _createVNode(_unref(ElTree), {
                              ref_key: "nationalRegionTreeRef",
                              ref: nationalRegionTreeRef,
                              style: {"max-width":"600px","min-width":"200px"},
                              data: data.nationalRegionData,
                              "node-key": "childCode",
                              "show-checkbox": "",
                              "check-on-click-node": "",
                              "filter-node-method": nationalRegionFilterNode,
                              onCheck: handleNationalRegionCheck
                            }, null, 8, ["data"])
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_2, [
                              _createElementVNode("span", {
                                style: _normalizeStyle(data.fontStyle)
                              }, _toDisplayString(data.showNationalRegionName), 5)
                            ])
                          ]),
                          _: 1
                        }, 512),
                        _createVNode(_component_el_dropdown, {
                          style: {"margin-top":"8px"},
                          onCommand: setLanguages
                        }, {
                          dropdown: _withCtx(() => [
                            _createVNode(_component_el_dropdown_menu, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_dropdown_item, { command: "CN" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("简体中文")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_dropdown_item, { command: "EN" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("english")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_3, [
                              _createElementVNode("span", {
                                style: _normalizeStyle(data.fontStyle)
                              }, "语言/Lan", 4)
                            ])
                          ]),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.buttons, (button) => {
                          return _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                            key: button.text,
                            type: button.type,
                            text: "",
                            class: "headerButton",
                            onClick: ($event: any) => (headerButtonClick(button.code))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                style: _normalizeStyle(data.fontStyle)
                              }, _toDisplayString(_unref($helper).lan(button.text)), 5)
                            ]),
                            _: 2
                          }, 1032, ["type", "onClick"])), [
                            [_vShow, button.isShow]
                          ])
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(topRightButtions), (button) => {
                          return (_openBlock(), _createBlock(_component_el_button, {
                            key: button.text,
                            type: button.type,
                            text: "",
                            onClick: ($event: any) => (topRightButtionClick(button.code)),
                            class: "headerButton headerButtonRight"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                style: _normalizeStyle(data.fontStyle)
                              }, _toDisplayString(_unref($helper).lan(button.text)), 5)
                            ]),
                            _: 2
                          }, 1032, ["type", "onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, {
                  id: "row122",
                  gutter: 5
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 21 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, { class: "searchCondition" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 3 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_row, { style: {"height":"40px"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_col, { span: 12 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_dropdown, {
                                          class: "searchLogoDropdown",
                                          onCommand: searchConditionDataType
                                        }, {
                                          dropdown: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchConditionDataTypeItemsShow), (dataType) => {
                                              return (_openBlock(), _createBlock(_component_el_dropdown_menu, {
                                                key: dataType.text
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_dropdown_item, {
                                                    command: dataType.value
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("img", {
                                                        alt: "logo",
                                                        src: dataType.icon,
                                                        style: {"width":"14px","height":"14px"}
                                                      }, null, 8, _hoisted_5),
                                                      _createTextVNode("  " + _toDisplayString(_unref($helper).lan(dataType.text)), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["command"])
                                                ]),
                                                _: 2
                                              }, 1024))
                                            }), 128))
                                          ]),
                                          default: _withCtx(() => [
                                            _createElementVNode("div", {
                                              class: "searchLogo1",
                                              style: _normalizeStyle(data.searchLogo1Style)
                                            }, [
                                              _createElementVNode("img", {
                                                alt: "checked",
                                                src: data.checkedsearchConditionDataTypeItem.icon
                                              }, null, 8, _hoisted_4)
                                            ], 4)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, {
                                      span: 12,
                                      class: "searchLogo2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("img", {
                                          alt: "logo",
                                          class: "element-plus-logo",
                                          src: _unref(searchTypeIconShow),
                                          onClick: searchTypeChange
                                        }, null, 8, _hoisted_6)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 18 }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  id: "searchInput",
                                  placeholder: _unref($helper).lan(data.checkedsearchConditionDataTypeItem.text),
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((data.searchInput) = $event)),
                                  onDrop: imageDrop,
                                  onKeydown: _withKeys(searchOperate, ["enter"]),
                                  onFocus: _cache[6] || (_cache[6] = ($event: any) => (showCodeHistory())),
                                  onBlur: _cache[7] || (_cache[7] = ($event: any) => (hideCodeHistory())),
                                  autocomplete: "off"
                                }, null, 40, _hoisted_7), [
                                  [_vModelText, data.searchInput]
                                ]),
                                _withDirectives(_createElementVNode("div", _hoisted_8, [
                                  _createElementVNode("div", _hoisted_9, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.codeSearchHistories, (code) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: code+_unref($helper).createID(),
                                        style: {"float":"left","width":"30%","padding":"5px"}
                                      }, [
                                        _createElementVNode("span", {
                                          style: {"cursor":"pointer"},
                                          onClick: ($event: any) => (codeHistoryClick(code))
                                        }, _toDisplayString(code), 9, _hoisted_10)
                                      ]))
                                    }), 128)),
                                    _hoisted_11
                                  ])
                                ], 512), [
                                  [_vShow, data.isShowCodeHistory]
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 3 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_col, {
                                      span: 12,
                                      class: "searchLogo3"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("input", {
                                          ref_key: "vinFileInput",
                                          ref: vinFileInput,
                                          type: "file",
                                          name: "vinFile",
                                          style: {"display":"none"},
                                          accept: "image/*",
                                          onChange: vinFileChange
                                        }, null, 544),
                                        _createElementVNode("img", {
                                          alt: "图片查询",
                                          class: "element-plus-logo",
                                          src: _imports_0,
                                          onClick: vinFileClick
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, {
                                      span: 12,
                                      class: "searchLogo4",
                                      style: _normalizeStyle(data.searchLogo4Style),
                                      onClick: searchOperate
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_12
                                      ]),
                                      _: 1
                                    }, 8, ["style"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 3 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, { class: "homeAndShoppingCar" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, {
                              span: 12,
                              style: {"border-right":"#CCC 1px solid"}
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("img", {
                                  alt: "logo",
                                  class: "element-plus-logo searchLogo5",
                                  src: _imports_2,
                                  onClick: gotoHome
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createElementVNode("img", {
                                  alt: "logo",
                                  class: "element-plus-logo searchLogo6",
                                  src: _imports_3,
                                  onClick: openProductRequirement
                                }),
                                _withDirectives(_createElementVNode("span", {
                                  class: _normalizeClass(data.productRequirements.length<10?'productRequirementStyle':'productRequirementStyle2')
                                }, _toDisplayString(data.productRequirements.length), 3), [
                                  [_vShow, data.productRequirements.length>0]
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, { class: "blankLine" }),
        _createVNode(_component_el_row, {
          style: _normalizeStyle(data.opetateClassifyStyle)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 3 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.carTypes, (carType) => {
                      return (_openBlock(), _createBlock(_component_el_col, {
                        span: 8,
                        key: carType.text
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_row, null, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("div", {
                                style: _normalizeStyle(data.checkedCarType == carType.code ? data.carTypesCheckedStyle : '')
                              }, [
                                _createElementVNode("img", {
                                  alt: "logo",
                                  class: "carTypeIcon",
                                  src: carType.icon
                                }, null, 8, _hoisted_13)
                              ], 4), [
                                [_vShow, carType.isShow]
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 17 }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  style: _normalizeStyle(data.productTypeElementStyle)
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.productTypes, (productType) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "productTypeElement",
                      key: productType.text,
                      style: {"float":"left"}
                    }, [
                      _createElementVNode("div", {
                        style: _normalizeStyle(data.checkProductTypes.indexOf(productType.code) > -1 ? data.checkProductTypesCheckedStyle : data.checkProductTypesUnCheckStyle),
                        onClick: ($event: any) => (checkProductTypeEvent(productType.code))
                      }, [
                        _createElementVNode("div", {
                          class: "checkProductType",
                          style: _normalizeStyle(data.fontStyle)
                        }, _toDisplayString(_unref($helper).lan(productType.text)), 5)
                      ], 12, _hoisted_14)
                    ]))
                  }), 128)),
                  _hoisted_15
                ], 4)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 4 }, {
              default: _withCtx(() => [
                (_unref($helper).hasPermission('baoYouLiangSearch'))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "",
                      text: "",
                      class: "productTypeButton",
                      style: _normalizeStyle( !data.baoYouLiangSearchButton ?data.buttonStyle1:data.buttonStyle2),
                      onClick: baoYouLiangSearchPage
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("strong", null, [
                          _createElementVNode("span", {
                            style: _normalizeStyle(data.fontStyle)
                          }, _toDisplayString(_unref($helper).lan('保有量')), 5)
                        ])
                      ]),
                      _: 1
                    }, 8, ["style"]))
                  : _createCommentVNode("", true),
                (_unref($helper).hasPermission('sizeSearch'))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      type: "",
                      text: "",
                      class: "productTypeButton",
                      style: _normalizeStyle(!data.sizeSearchButton?data.buttonStyle1:data.buttonStyle2),
                      onClick: sizeSearchPage
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("strong", null, [
                          _createElementVNode("span", {
                            style: _normalizeStyle(data.fontStyle)
                          }, _toDisplayString(_unref($helper).lan('尺寸')), 5)
                        ])
                      ]),
                      _: 1
                    }, 8, ["style"]))
                  : _createCommentVNode("", true),
                (_unref($helper).hasPermission('carModelSearch'))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 2,
                      type: "",
                      text: "",
                      class: "productTypeButton",
                      style: _normalizeStyle( !data.carModelSearchButton ?data.buttonStyle1:data.buttonStyle2),
                      onClick: carModelSearchPage
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("strong", null, [
                          _createElementVNode("span", {
                            style: _normalizeStyle(data.fontStyle)
                          }, _toDisplayString(_unref($helper).lan('车型')), 5)
                        ])
                      ]),
                      _: 1
                    }, 8, ["style"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["style"])
      ], 4),
      _createElementVNode("div", _hoisted_16, [
        (data.showListType==''||data.showListType=='productList')
          ? (_openBlock(), _createBlock(productList, {
              key: 0,
              loading: data.loading,
              tableData: data.tableData,
              tableDataSource: data.tableDataSource,
              searchInput: data.searchInput,
              isOperateSearch: data.isOperateSearch,
              checkProductTypes: data.checkProductTypes,
              newProductTime: data.newProductTime,
              onUpdatedProductRequirement: updatedProductRequirement,
              onShowSizeSearchData: showSizeSearchData,
              onSearching: searching,
              onSearched: searched,
              onShowNewProductSearchData: showNewProductSearchData
            }, null, 8, ["loading", "tableData", "tableDataSource", "searchInput", "isOperateSearch", "checkProductTypes", "newProductTime"]))
          : _createCommentVNode("", true),
        (data.showListType=='carModelList')
          ? (_openBlock(), _createBlock(carModelList, {
              key: 1,
              loading: data.loading,
              tableDataJson: data.carModelSearchData,
              productTypesChecked: data.checkProductTypes,
              totalMsg: data.carModelSearchDataTotalMsg
            }, null, 8, ["loading", "tableDataJson", "productTypesChecked", "totalMsg"]))
          : _createCommentVNode("", true),
        (data.showListType=='baoYouLiangList')
          ? (_openBlock(), _createBlock(baoYouLiangList, {
              key: 2,
              loading: data.loading,
              searchParamJson: data.baoYouLiangSearchParam,
              tableDataJson: data.baoYouLiangSearchData,
              productTypesChecked: data.checkProductTypes,
              totalMsg: data.baoYouLiangSearchDataTotalMsg
            }, null, 8, ["loading", "searchParamJson", "tableDataJson", "productTypesChecked", "totalMsg"]))
          : _createCommentVNode("", true)
      ])
    ], 4)
  ], 64))
}
}

})